const createDeferred = ()=>{
    let resolve;
    let reject;
    const ac = new AbortController();
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        ac,
        resolve,
        reject
    };
};

export { createDeferred };
